import "./ErrorModal.css";

interface Reponse {
    message?: string;
    error?: string;
}

interface Props {
    isOpen: boolean;
    error: Reponse | null;
    onClose: () => void;
}

function ErrorModal({ isOpen, onClose }: Props) {
    if (!isOpen) return null;

    const errorMessage =
        "Une erreur est survenue lors du traitement de votre demande. Veuillez vérifier vos informations et réessayer. Si ce problème persiste, veuillez contacter un administrateur.";

    return (
        <div className='error-modal-overlay'>
            <div className='error-modal-content'>
                <h2>Oops !</h2>
                <p className='error-message'>{errorMessage}</p>
                <button className='close-button' onClick={onClose}>
                    Fermer
                </button>
            </div>
        </div>
    );
}

export default ErrorModal;
